<template>
  <v-progress-linear v-model="data.postings[0]" :color="data.postings[1]" height="20">
    <strong>{{ data.postings[0] }}%</strong>
  </v-progress-linear>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.v-progress-linear__content {
  display: flex;
  align-items: center;
  justify-content: center;

  strong {
    font-size: 10px;
  }
}
</style>